import React, {Component} from 'react'
import {observer, inject} from 'mobx-react'
import {Redirect} from 'react-router-dom'
import DocumentTitle from 'react-document-title'

import style from './passwordRecovery.sass'

@inject('store') @observer
class PasswordRecoverySuccess extends Component {
  componentWillUnmount() {
    this.props.store.auth.change('passwordReset', false)
  }
  calculateHeight = () => {
    let footerHeight = 0
    const footer = document.querySelector('footer')
    if (footer) {
      footerHeight = footer.getBoundingClientRect().height
    }
    return window.innerHeight - footerHeight
  }
  render() {
    const {passwordReset} = this.props.store.auth
    if (!passwordReset) {
      return <Redirect to='/'/>
    }
    return(
      <div style={{height:this.calculateHeight()}} styleName='wrapper'>
        <DocumentTitle title='Password Recovery'/>
        <div styleName='banner'/>
        <div styleName='card'>
          <p>We have sent you an e-mail. Please contact us if you do not receive it within a few minutes.</p>
        </div>
      </div>
    )
  }
}

export default PasswordRecoverySuccess
